<template>
  <div v-if="events && events.length" class="events">
    <EventsSlider :events="events" :title="$t('events_title')" />
    <div class="page-container">
      <p class="events__text">{{ $t('events_description_text') }}</p>
      <a class="events__link" :href="urlLanguagePrefix + '/news/sobytiya/'">{{ $t('events_all_news') }}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventsSlider from './EventsSlider'
import api from '../../api'

export default {
  name: 'EventsBlock',
  components: { EventsSlider },
  data () {
    return {
      events: null
    }
  },
  props: {
    cityIds: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix'])
  },
  watch: {
    cityIds: {
      immediate: true,
      handler (ids, prevIds) {
        if (String(ids) !== String(prevIds)) {
          api.events.getEvents(ids)
            .then((res) => {
              if (res.success && res.data?.events) {
                this.events = res.data.events
              } else {
                this.events = null
              }
            })
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">

.events
  background-color: #f8f8f8
  padding: 25px 0 40px

  +mmin($tablet--hor)
    padding: 80px 0 110px

.shops-events .events
  margin-top: 30px

  +mmin($tablet--hor)
    margin-top: 60px

.events__text
  width: 100%
  max-width: 768px
  font-size: 12px
  color: $placeholder-color

  +mmin($tablet)
    font-size: 16px
    margin: 45px 0 25px

.events__link
  color: $text-color
  font-size: 16px
  border-bottom: 1px solid $text-color

  &:hover
    border-color: transparent

</style>
